// extracted by mini-css-extract-plugin
export default {"calendar__icon":"Calendar_calendar__icon__TX9lh"};